import React from "react";
import { Button } from "antd";
import isEmpty from "lodash/isEmpty";
import isString from "lodash/isString";
import uniq from "lodash/uniq";
import WeaLocaleProvider from "../../wea-locale-provider";
import WeaTools from "../../wea-tools";
import { initialState } from "./propType";

const { getLabel } = WeaLocaleProvider;

// 点击“确定”按钮时，处理返回数据
export function handleOk() {
  const { selectedData, inputId, inputName } = this.state;
  const { maxLength } = this.props;
  let values = [];
  if (!isEmpty(selectedData)) {
    if (maxLength && maxLength < this.count(selectedData, true)) {
      window.alert(`所选的数量不能超过${maxLength}!`);
      return;
    }
    selectedData.forEach(item => {
      item.id = item[inputId] || item.id;
      item.name = item.orgWholePathspan || item[inputName] || item.name || "";
      values.push(item.id);
    });
  }
  values = uniq(values);
  if (this.props.onBeforeBrowserOK) {
    let cb = this.handleOkInner.bind(this);
    this.props.onBeforeBrowserOK(values, selectedData, cb);
  } else {
    this.handleOkInner(values, selectedData);
  }
}

export function handleOkInner(values, selectedData) {
  this.onChange(selectedData);
  this.props.onClose && this.props.onClose();
  if (this.isCrm() && values.length > 0)
    WeaTools.callApi(`/api/public/browser/data/${this.props.type}`, "post", {
      cmd: "addList",
      ids: values.join(",")
    });
}

// 点击“清除”按钮事件回调
export function handleClear() {
  this.setState({ idCache: "", nameCache: "" });
  this.associative && this.associative.clear && this.associative.clear();
  this.onChange([]);
}

// 点击“取消”按钮事件回调
export function handleCancel() {
  this.closeModal();
  this.setState(initialState);
  this.props.onCancel && this.props.onCancel();
  this.props.onClose && this.props.onClose();
}

// 获取madal底部按钮
export function getModalFooter() {
  const { isSingle, buttons, bottomLeft, browserModalProps } = this.props;
  const { contentType, selectedData, activeKey } = this.state;
  const disabled = selectedData.length === 0;
  const footer =
    buttons ||
    [
      ((isSingle && contentType == 3) || !isSingle) && (
        <Button
          key="submit"
          type="primary"
          disabled={disabled}
          onClick={this.handleOk}
        >
          {[
            getLabel(385565, "确 定"),
            isSingle || disabled ? "" : this.count(selectedData)
          ]}
        </Button>
      ),
      (isSingle ||
        (!isSingle &&
          (!browserModalProps || !browserModalProps.hideClear))) && (
        <Button key="clear" type="ghost" onClick={this.handleClear.bind(this)}>
          {getLabel(385566, "清 除")}
        </Button>
      ),
      <Button key="back" type="ghost" onClick={this.handleCancel}>
        {getLabel(385567, "取 消")}
      </Button>
    ].filter(Boolean);
  if (bottomLeft) {
    const left = isString(bottomLeft) ? (
      <span dangerouslySetInnerHTML={{ __html: bottomLeft }} />
    ) : (
      <span>{bottomLeft}</span>
    );
    footer.unshift(
      <div
        className="ext-link"
        style={{ float: "left", cursor: "pointer", paddingLeft: 20 }}
      >
        {left}
      </div>
    );
  }
  return footer;
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/browser/getModalFooter.js